module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CHAPTER 1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("W")])]), _vm._v("ithin five minutes of opening the door, Maura Phillips knew she’d made a mistake. A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("big")]), _vm._v(" mistake!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d come flying in from the back patio and swung open the door on the third ring of the bell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello, Jake,” she said breathlessly, smiling up at the tall, dark-haired man standing on the step of her rented cottage. “Sorry I didn’t hear the doorbell. I was out on the patio.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Colonel Jake McAllister, deputy commander for Operations at Eglin Air Force Base, lifted a brow. “Hello, Maura. I didn’t get the dates mixed up, did I?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” she laughed, raking a hand through her breeze-tossed brown bob. “I’m just running a little "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v("late. I still can’t get used to this gorgeous Florida sunshine after all those years of L.A. smog. Every time I go out on the patio and see sunlight sparkling on the water, I fall into a daze.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maura stood aside as he entered the house. Her own brows arched delicately at her first full view of Jake McAllister in something other than his Air Force uniform.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tonight he wore tailored dark slacks and a crisp blue cotton shirt with the sleeves folded back neatly to reveal tanned forearms. Shiny leather loafers and a chain-link ID bracelet on his right wrist gave him a casual, elegant look. With his dark hair and cool gray eyes, he exuded an aura of restrained sophistication. Very restrained. Even in civilian clothes, the colonel carried an air of authority.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The first warning bell sounded in Maura’s mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why don’t you wait in the living room? I’ll just be a moment.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nodding, he followed as she wove a path around the half-unpacked boxes littering the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just moving in?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. Actually, I rented this place through a real estate agent sight unseen and had my things shipped out from L.A. Bea and I have been here going on a month now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded to the massive ball of orange fur rubbing itself against a chair leg. Turning back, she just caught the expression on Jake’s face as he did a quick sweep of her disordered living room.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Uh-oh, she thought, he’s not into clutter. The second warning bell began to ping.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I call it the primitive look,” she told him, a deliberately bland look in her hazel eyes. Housekeeping wasn’t very high on her list of priorities in life. In fact, it didn’t even "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("make")]), _vm._v(" the list. But she was darned if she was going to apologize or explain herself. She’d done enough of that before she’d left L.A.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake sensed he’d offended her, and his face softened. One side of his mouth drew up in a rueful smile, crinkling the skin at the corners of his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I guess we military types are more used to packing and unpacking. Moving every few years or so, we get compulsive about putting the nest in order quickly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maura took the proffered olive branch with a smile only a few shades less brilliant than her normal cheerful grin. “I’ll bet you’re one of those disgusting types who have all the boxes unpacked, the shelves put together, and your books lined up by color and size before the moving van even leaves.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, no. I line them up alphabetically by author,” he confessed, his smile widening.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fascinated by the way a simple rearrangement of a few facial muscles could transform the strong, angled planes of his face into a lopsided—and devastatingly potent—male grin, Maura almost missed his next comment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m probably a little early,” he continued. “Another compulsive military trait, I suppose. Please, take whatever time you need to get dressed.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maura blinked and caught her jaw in middrop. She was as dressed as she intended to be for a casual dinner at the home of a co-worker. All she had left to do was drag a brush through her hair and dig through the boxes in her bedroom for a light wrap.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She glanced down at her turquoise leggings and matching, thigh-length silk tunic. Okay, they might look a bit like lounging pajamas to the uninitiated. Or to conservative, polished-loafer types.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Warning bells were going off like Klaxons now. For a few moments, a desire to tell a certain colonel what he could do with his gracious offer of time warred with her ready sense of the ridiculous. Her sense of humor won. The man wanted dressed, dressed he’d get.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks.” She responded to his offer with only the tiniest hint of dryness in her voice. “I shouldn’t be long. The bar’s over there. Help yourself to a drink if you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nodding to the antique sideboard shoved up against one wall, she started down the short hall leading to her bedroom. She’d taken only a few steps when Jake’s startled exclamation stopped her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey! Let go, cat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maura turned to see him extracting a set of claws from his pant leg. “Beatrice! For heaven’s sake, behave yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hurrying back, she scooped up the lump of orange fur. The cat hung from her arms, its eyes a picture of limpid innocence.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry about that. If it’s any consolation, Bea just used up her entire energy supply for the next week. You’re safe now.” Stroking her pet’s thick fur, Maura turned a wide, guileless gaze on the man watching them both warily. “She doesn’t seem to like men for some reason.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She probably senses it’s mutual.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With another stern admonition to behave, Maura put the cat down. The animal settled itself on its haunches and fixed the visitor with an unwavering stare.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As his date for the evening disappeared down the hall, Jake’s glance drifted to the malevolent-looking creature hunkered at his feet. Nothing like a set of claw marks to start the evening off right. Deciding to take Maura up on her offer of a drink, he made his way through the jumble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no other word to describe it. A sophisticated computer perched precariously on an impromptu desk made of heavy boards and concrete blocks. The laptop battled for space with stacks of manuals and haphazardly piled books. A miniaturized set of stereo components sat in one corner, with speaker wires strung carelessly to the four corners of the room. Bright floral rattan furniture, obviously rented with the house, sat side by side with what his assessing eye pegged as genuine antiques. That makeshift bar was a genuine Sheraton sideboard, Jake knew. His ex-wife hadn’t left him with much, but she had given him an appreciation of fine old furniture.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he poured a neat Scotch, his thoughts turned to the owner of all this clutter. From the little he’d seen of her at work, the woman had a personality as contradictory as her interior decorating scheme, or lack thereof. With her sleek brown mane, colorful attire and cheerful grin, Maura Phillips turned heads every time she breezed by. The fact that her undeniably delectable body housed a razor-sharp mind only added to the stunned amazement she left in her wake.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jake had been in one or two meetings with her since her arrival and had to admit she knew her stuff. He just couldn’t reconcile someone with a Ph.D. from Stanford with her flashy good looks and this hodgepodge house. An engineer to his bones, he liked things neat and precise on the outside as well as the inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he made his way back across the room, a long, slow hiss warned him to watch where he stepped. He restrained the impulse to hiss back and wished he’d declined this dinner invitation.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Absently, Jake swirled the Scotch. What was it about his divorced state that made his friends and co-workers think they had a moral obligation to fix him up with every available female of their acquaintance? Usually Jake managed to finesse their not-very-subtle matchmaking attempts. He and his wife had split up more than three years ago, but the regret—and wariness—still lingered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Their daughter was the one bright, shining joy to survive the bust-up. She was staying with Jake for "), _c('a', {
    attrs: {
      "id": "page15"
    }
  }), _vm._v("the summer and he’d planned to take her to a movie tonight. Against his better judgment, though, he’d let himself be talked into dinner with Pete Hansen, his wife, and Maura Phillips.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Assuming")]), _vm._v(" they even made it to Pete’s in time for dinner, Jake amended, glancing down at his watch. He tried to shrug off the delay, but lateness, like untidiness, offended his orderly soul. He downed a swallow of Scotch and wondered what the heck was taking so long.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Down the hall, Maura attacked the boxes stacked beside her bed with a determined glint in her brown eyes. Someday, she thought. Someday she’d learn to listen to her instincts. So this Jake McAllister was a world-class hunk, not classically handsome but lean and strong and all male. So he looked as good in his air-force uniform as he did in the casual clothes he wore tonight. So he had a breath-stopping smile that made her heart thump. He was all wrong for her and she knew it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man radiated cool authority in every inch of his body. Having worked for most of her adult life in a career field dominated by men, Maura had long ago learned to hold her own against these authoritarian types. She’d also stopped trying to curb her own ebullient personality to fit their preconceived notions of how she should look and dress.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still, she hadn’t missed the faint disapproval in Jake McAllister’s gray eyes when he surveyed her home—and herself! Maura wished fervently she’d "), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _vm._v("declined Pete’s invitation. Or at least insisted on driving herself when he suggested Jake pick her up, since she was still learning her way around the Gulf Coast.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Oh, well. She might as well make the best of the situation and have some fun. With a grin, she pulled a wide magenta belt out of the box and fastened it low on her hips. The purply red stood out like a bold slash against her turquoise tunic. More digging produced dangly earrings composed mostly of bits of seashells and feathers on varying lengths of colored leather. On impulse, she exchanged her low-heeled sandals for strappy platforms with ties that wrapped around her ankles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Teasing her hair unmercifully, she pulled a thick swatch to one side of her head and caught it with a sparkly gold lamé scrunchie left over from some Christmas party. A few quick strokes dramatically deepened the eye shadow and blusher she’d put on earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There, she thought with a wicked smile as she surveyed herself in the mirror. That’s dressed!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stopping to pick up the bouquet of fresh flowers she was taking as a hostess gift, she sailed down the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“All set.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her transformation put a startled look in Jake’s eyes, but he refrained from comment. Smart man, Maura thought as they strolled out into the Florida night.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("From that inauspicious beginning, things went downhill fast. As they drove through the soft summer evening, Maura’s suspicion she had little in common with this man aside from the fact they both worked at the base became absolute certainty. Politely, they agreed to disagree on music and their preference in cars, and not so politely on the St. Louis Rams’ chances this season. Obviously struggling to find a safe topic, Jake finally steered the conversation to work.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So how do you like Eglin?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I love it,” Maura responded with a touch of her usual enthusiasm. “A friend of a friend who used to be stationed here told me about the base. When I saw an ad in a trade journal for a test manager with my specialty, I decided to send in my résumé. But I had no idea how gorgeous this area really is, or how exciting the work would be.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shot her a quick look. “You made a major career move based on third-hand information from a friend?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I believe in following my instincts,” she replied, a distinct challenge in her tone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Most of the time, she amended silently. She just had to learn to follow them better when it came to uptight, controlled men.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Haven’t you ever done anything just because you knew instinctively it was right, not because it was logical or prudent or expected?”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page18"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not since I passed puberty,” he responded dryly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, come on, Colonel. You’re a test pilot. Surely flying one of the world’s most advanced high-tech aircraft is as much instinct as skill?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An amused smile hovered at the edges of his mouth. “You’ve been watching too many Tom Cruise movies. What we do up there takes years of training and a precise mind, along with the ability to make split-second decisions.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maura battled a growing irritation. The analytical side of her intellect knew he was right, but the romantic in her didn’t want her illusions about dashing test pilots reduced to cool calculation and a slide rule.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So how did you get into the business of flying?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s all I’ve ever wanted to do,” he replied with a shrug. “Even as a kid, I planned on going to the academy and then flying. Every assignment helped improve my skills.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maura caught the unspoken message. He’d set a deliberate career path and followed it. Unlike her, whose professional goals were erratic at best. With a sigh, she gave up all attempts at conversation and turned to watch the scenery rolling past the open car windows.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They crossed the bridge linking the small town of Fort Walton Beach with Santa Rosa Island, a long, narrow strip of sand that ran for fifty miles along the Gulf of Mexico. On one side of the island Maura could see the emerald-green waters of the Gulf "), _c('a', {
    attrs: {
      "id": "page19"
    }
  }), _vm._v("crashing in lacy waves against snow-white beaches. On the other side, Choctawhatchee Bay stretched to the horizon. Along a distant curve of the bay, she could barely make out the huge hangars and tall buildings of Eglin Air Force Base.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Since Eglin owned most of the eastern half of Santa Rosa Island, the land was protected in its natural state. Maura relaxed, enjoying the sharp tang of the ocean and the sight of tall, feathery sea grass swaying in the evening breeze.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After crossing a second bridge over the narrow inlet where the bay washed into the sea, they reentered civilization. High-rise condominiums crowded against neon-lit tourist shops and restaurants in what had once been the sleepy fishing village of Destin. Pete Hansen lived in the tallest of the condominiums along the shore.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When her co-worker opened the door a few moments later, he eyed her bright plumage appreciatively.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maura, you look so, er, vibrant. Come on in. Honey, this is Maura Phillips, the new test manager I told you about.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve heard a lot about you, Dr. Phillips,” the cool blonde at his side responded, offering a delicate hand in greeting. “Pete’s raved about the way you’ve brought the latest technology and a California look to our little redneck corner of the woods.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Smiling, Maura shrugged off the cattiness of the woman’s remarks. “I prefer to think of it as my own look.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She doubted if her hostess even heard her. The woman had turned to greet her other guest, upping the wattage of her smile considerably.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello, Jake.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hi, Carol.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stretched to give him a warm kiss. The natives were friendly, Maura thought as Jake bent and took the kiss on the cheek. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Very")]), _vm._v(" friendly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This way,” Pete said, ushering his guests into his home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maura’s smile came out in its full, natural force when she followed him into the spacious living room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, this is fabulous!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The room combined understated elegance with sweeping vistas. Berber carpets and walls textured in grass paper reflected the shifting sand dunes outside. The far wall was a solid sheet of glass with a spectacular view of the Gulf.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Carol did all the decorating herself.” Pete beamed at his wife as he escorted his guests out onto the balcony. “She could go into interior design professionally if she wanted to.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And I thought I was lucky to find my little bayside cottage,” Maura said with a sigh, sinking into one of the lounge chairs to absorb the full glory of a flaming-red sun hovering above the dark green waters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It wasn’t easy to get into this condo,” Pete confided. Pouring margaritas from a frosty pitcher, he "), _c('a', {
    attrs: {
      "id": "page21"
    }
  }), _vm._v("passed them to his guests before settling his lanky frame onto a lounge chair. “The pittance we poor civil servants earn barely covers the maintenance fees. I thought we’d have to hock Carol’s jewelry for the down payment.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, come on, Pete.” His wife’s voice carried a hint of annoyance. “You know it’s not that bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, I hope you saved enough for insurance,” Jake put in, and deftly steered the conversation away from the apparently rocky shoals of domestic finances to the upcoming hurricane season. Maura had already participated in one hurricane watch since her arrival. Weather was a favorite topic of conversation on this part of the coast, she’d discovered, right after Miami Dolphins football.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She tried to warm up to her hostess over dinner. Carol had obviously gone to considerable effort on her guests’ behalf. Heavy gleaming silver and sparkling crystal decorated the table, with an exquisite bird-of-paradise blossom in a Lalique holder at each place setting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pete’s right,” Maura offered sincerely. “You have a wonderful flair for decorating.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you.” Her long, manicured fingers stroked her crystal goblet sensuously. “I think a beautifully ordered setting helps create an inner serenity, don’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Amusement flickered in the gray eyes directly across the table from Maura. She could see Jake waiting expectantly for her response.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page22"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, I do.” She gave her hostess a polite smile. “Of course, we all find beauty in different ways. I, for one, like lots of splashy color.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know Jake appreciates clean, pure lines,” Carol purred. “He’s got a fabulous place across the bay.” The look she sent him from under lowered lashes suggested an intimate knowledge of his home—among other things.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A tinge of red crept up Jake’s cheekbones as he gave a light answer and changed the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sooo, Maura thought. Our hostess has the hots for the dashing Colonel McAllister. Repressing a twinge of something she couldn’t quite analyze, she glanced at her host. Pete was energetically tossing the Caesar salad, but the faint crease between his brows told her he hadn’t missed his wife’s provocative remark.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maura stepped in to cover the awkward moment. “You’ll have to tell me where to shop around here. I’ve been so busy at work I haven’t had time to hit the malls.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sandestin has some nice little shops,” her hostess replied with a polite smile. “Although I doubt they’ll have anything quite as stylish as the boutiques in L.A.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Or as expensive,” Maura agreed, laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pete gave her a grateful glance and kept the ball rolling by pumping her about L.A. Allowing her natural liveliness full rein, Maura exhausted her store of anecdotes about traffic tangles, star sightings and mail carriers on in-line skates. By the time Carol "), _c('a', {
    attrs: {
      "id": "page23"
    }
  }), _vm._v("brought in the coffee, she couldn’t wait for the awful evening to be over.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Riding home through the soft, starry night, she fought the beginnings of a headache. Her gushing chatter had drained both her energy and her enthusiasm. With a small sigh, she leaned her head back against the soft leather seat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Would you mind telling me what that was all about?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The deep, gravelly voice coming at her out of the darkness made Maura jump. “What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I mean your performance tonight. You played the breathless California girl to perfection.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maura’s eyes narrowed to dangerous slits. She forgot that she’d been late and kept this man waiting. She forgot that she’d deliberately dressed like a refugee from a floating rummage sale. She even ignored the fact that she’d prattled inanely for most of the evening, giving even herself a headache with her chatter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not sure what qualifies you as an expert on California girls,” she responded with soft, deadly sweetness, “but I’m surprised you wanted to go out with me if you have such a low opinion of the species.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shot her a cool look. “Let’s keep the record straight. This wasn’t a date. When and if we do go out, we won’t spend the evening dueling over everything from sports to how we should have finished the job in Iraq.”")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page24"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I stand corrected,” Maura said icily. “This wasn’t a date. And for the record, there won’t be any ‘when’ or ‘if.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her temper was still simmering when they pulled into the crushed-shell driveway beside her house. She had the passenger door open before the car rolled to a stop.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks for the ride, Colonel. I won’t say it’s been fun. You don’t need to walk me to the door.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With another cool glance, McAllister levered himself out of the low-slung sports car. Following in her wake, he waited while she fit her key in the lock.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Determined to end this fiasco, Maura turned. Too quickly, as it turned out. The ridiculously high platforms wobbled. She teetered on the small stoop and pitched forward.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("McAllister moved fast. Whipping out an arm, he snagged her against his chest. She looked up, totally embarrassed, to see a wicked glint come into his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re right,” he drawled. “This evening hasn’t been fun. Until now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was that damned grin that threw her. Maura was still trying to figure out how the man could go from cool and remote to rogue male in the blink of an eye when he swooped in for a kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The kiss stunned her. It was the last thing she’d expected after the disaster of the evening. While her mind struggled to deal with his impulsive act, her body cataloged the sensations he was bringing to it.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page25"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man could kiss. She’d give him that. His mouth moved over hers with a skill that sent tingles rippling down her spine. She was almost disappointed when he set her back on her feet and tipped her a casual salute.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“See you around.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not if I see you first,” she muttered as he headed back to his car.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Confused and irritated at her body’s reaction to the man, she let herself into the house, wandered into the living room and tossed her bag at the closest chair. When the chair let out a yowl, she nearly jumped out of her skin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry, Bea!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Scooping up the indignant cat, she dropped into the chair and leaned her head against the high cushions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I was right. The man is everything I don’t like. Stuffy, conservative, judgmental. I should have taken my own car tonight. I should have avoided the darned dinner altogether when Pete told me he’d invited McAllister, too. And I sure as heck should have been the one to break off that kiss!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maura rubbed the cat’s fur and tried to relax, but the night had left her with a jumble of contradictory feelings that wouldn’t go away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s what she got for letting a long, lean body and sexy grin overcome her better judgment. She and take-charge, in-control types just didn’t mix. She ought to know. She’d left one just like him behind in L.A. Shaking her head, she kneaded the cat’s spine.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page26"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“When am I going to learn?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bea’s heavy body rumbled in a purr, but otherwise she ignored the question. Scooping her up, Maura marched them both off to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "star"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("A frown creased Jake’s forehead as he drove through the soft Florida night. He couldn’t believe he’d given in to the impulse to kiss the woman who’d tumbled so conveniently into his arms. She was a mass of contradictions, as prickly as she was outspoken. He couldn’t figure her out, and his neat, orderly mind hated that kind of ambiguity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One thing was clear, though. His body wasn’t experiencing the least ambiguity. Just the memory of her mouth under his put a kink in his gut that wouldn’t quit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shifted in the bucket seat, trying to erase the discomfort with a healthy dose of common sense. The scars from his divorce had pretty much healed, but he’d learned his lesson. He intended to look long and hard before he took another leap into the pool. Particularly with a woman as confusing as Maura Phillips.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a distinct twinge of regret, Jake decided he’d best avoid her in the future. Eglin was a big base, the largest in the world. It had more than five hundred square miles of test range and ate up half of the Florida panhandle. Surely that was enough room to keep some distance between him and this particular female.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b6c9128","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter01.vue
// module id = 66
// module chunks = 0